<template>
  <el-dialog custom-class="pc-dialog pc-dialog__upload-image pc-dialog__upload-avatar"
    title="上传头像"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="closeHandler"
    @open="openHandler"
    >
    <div class="pc-dialog__upload-image-area">
      <div class="pc-dialog__upload-image-empty" v-show="imageEmpty"
        @click="selectFileHandler">
        <div class="icon">
          <i class="el-icon-upload"/>
        </div>
        <div class="options">
          <span>点击当前区域选择本地文件</span>
        </div>
        <input type="file" ref="uploadFile" @change="hanleUploadFileChangeHandler" accept="image/jpeg,image/png" />
      </div>
      <div class="pc-dialog__upload-image-preview" v-show="!imageEmpty">
        <img ref="image" :src="imageSrc" @load="handleImageOnloadHandler"/>
        <!-- <el-button type="text" class="reset" @click="resetHandler">重置</el-button> -->
      </div>
    </div>
    <div slot="footer" class="pc-dialog__upload-avatar-footer">
      <el-button type="primary" size="small" @click="okHandler" :disabled="waiting">确认上传头像</el-button>
      <el-button size="small" @click="resetHandler">重置</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Cropper from 'cropperjs'
import { operateError } from '@/common/errors'

export default {
  data () {
    return {
      imageEmpty: true,
      imageSrc: '',
      waiting: false,
      imageFile: null,
      cropper: null
    }
  },
  computed: {
    ...mapGetters('dialog', {
      uploadAvatar: 'uploadAvatar'
    }),
    visible: {
      get () {
        return this.uploadAvatar.visible
      },
      set (value) {
        this.setUploadAvatar({ visible: value })
      }
    }
  },
  methods: {
    ...mapMutations({
      setUploadAvatar: 'dialog/SET_UPLOAD_AVATAR'
    }),
    ...mapActions({
      updateAvatar: 'auth/updateAvatar'
    }),
    closeHandler () {
      if (this.cropper) {
        this.cropper.destroy()
      }
      this.$refs.uploadFile.value = null
      this.imageEmpty = true
      this.imageSrc = ''
      this.waiting = false
      this.imageFile = null
      this.cropper = null
    },
    openHandler () {},
    okHandler () {
      const that = this
      this.cropper.getCroppedCanvas().toBlob(async (blob) => {
        const formData = new FormData()
        formData.append('file', blob)

        that.waiting = true

        try {
          await that.updateAvatar(formData)
          that.$message({
            type: 'success',
            message: '修改头像成功'
          })
          that.setUploadAvatar({
            visible: false
          })
        } catch (error) {
          operateError(error, '上传头像')
        } finally {
          that.waiting = false
        }
      }, 'image/jpeg', 0.5)
    },
    selectFileHandler () {
      this.$refs.uploadFile.click()
    },
    hanleUploadFileChangeHandler () {
      const file = this.$refs.uploadFile.files[0]
      if (!file) {
        return
      }
      const that = this
      const reader = new FileReader()
      reader.onload = (e) => {
        that.imageEmpty = false
        that.imageSrc = e.target.result
        that.imageFileName = file.name.split('.')[0]
        that.imageFile = file
      }
      reader.readAsDataURL(file)
    },
    handleImageOnloadHandler () {
      // const that = this
      this.$nextTick(() => {
        this.cropper = new Cropper(this.$refs.image, {
          ready: (event) => {
          },
          aspectRatio: 1,
          zoom: (event) => {
            event.preventDefault()
          }
        })
      })
    },
    resetHandler () {
      this.closeHandler()
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

.pc-dialog__upload-avatar {
}
</style>
